import Modal from "@via/components/modal.tsx";
import { ModalSize } from "@via/utils/constants.tsx";
import { HorizontalTabs } from "@via/components/tabs.tsx";
import CreatePipelineForm from "@via/pages/pipelines/create-pipeline/create-pipeline-form.tsx";
import ImportPipelineForm from "@via/pages/pipelines/create-pipeline/import-pipeline-form.tsx";
import { type FC } from "react";
import { SelectOption } from "@via/utils/interfaces.tsx";

interface CreatePipelineModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  menuGroups: SelectOption[];
  showImportViaPipelineButton?: boolean;
  openImportViaPipelineModal?: (open: boolean) => void;
}

const CreatePipelineModal: FC<CreatePipelineModalProps> = ({
  open,
  setOpen,
  menuGroups,
  showImportViaPipelineButton = false,
  openImportViaPipelineModal = () => {},
}) => {
  return (
    <>
      <Modal
        open={open}
        setOpen={setOpen}
        title="Create New Pipeline"
        showButtons={false}
        size={ModalSize.Large}>
        <HorizontalTabs
          buttonIdPrefix="create-new-pipeline"
          options={[
            {
              name: "Create",
              children: (
                <CreatePipelineForm menuGroups={menuGroups} setOpen={setOpen} />
              ),
            },
            {
              name: "Import",
              children: (
                <ImportPipelineForm
                  setOpen={setOpen}
                  showImportViaPipelineButton={showImportViaPipelineButton}
                  openImportViaPipelineModal={openImportViaPipelineModal}
                />
              ),
            },
          ]}
        />
      </Modal>
    </>
  );
};

export default CreatePipelineModal;
